import {Spin} from 'antd';

export default function Spinner() {
    return <Spin className="Boundary-spin" />;
}
